import React from "react";

import { RectSkeleton } from "shipnow-mercurio";

export const TwoRectSkeleton = () => {
  return (
    <>
      <RectSkeleton margin="b-8" size="lg" width="70%" />

      <RectSkeleton size="md" width="70%" />
    </>
  );
};
